/**
 * 只能输入数字
 * @param {*} number 
 */
export function formatMathDecimal(number) {
    var numReg = /^[\+\-]?\d*?\.?\d*?$|^([^0][0-9]+|0)$/
    var numRe = new RegExp(numReg)
    if (!numRe.test(number)) {
        return false
    }
    return true
}

export function formatMathOrLetter(str) {
    var numReg = /^[0-9a-zA-Z]*$/
    var numRe = new RegExp(numReg)
    if (!numRe.test(str)) {
        return false
    }
    return true
}